import {
  CurrencyInputController,
  FiscalYearEndInputController,
  OrganizationDetailFragment,
} from '@alice-financial/alice-sdk'
import { Button, Grid } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { useFinancialInformationForm } from './useFinancialInformationForm'

interface FinancialInformationFormProps {
  org: OrganizationDetailFragment
}

export const FinancialInformationForm = ({ org }: FinancialInformationFormProps) => {
  const { control, onSubmit, isLoading, isFormValid } = useFinancialInformationForm(org)

  return (
    <form onSubmit={onSubmit}>
      <Grid container spacing={3} flexDirection="column">
        <Grid size={{ xs: 12, sm: 8 }}>
          <CurrencyInputController
            name="annualRevenue"
            control={control}
            label="Annual revenue"
            variant="outlined"
            fullWidth
            helperText="Enter your organization's annual revenue. This field is required if you provide a fiscal year end."
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 8 }}>
          <FiscalYearEndInputController
            name="fiscalYearEnd"
            control={control}
            label="Fiscal year end"
            helperText="Enter the month and day when your fiscal year ends (e.g., 12-31 for December 31st). This field is required if you provide annual revenue."
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 8 }}>
          <Button type="submit" variant="contained" disabled={isLoading || !isFormValid}>
            {isLoading ? 'Saving...' : 'Save accounting information'}
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}
